<template>
    <select
        :class="className"
        v-bind="passedAttrs"
        :value="value"
        @change="onInputChange"
    >
        <option v-if="placeholder" value="" disabled :selected="isEmpty()">
            {{ placeholder }}
        </option>
        <slot />
    </select>
</template>

<script lang="ts">
    import omit from 'lodash/omit';
    import { Component, Prop, Vue } from 'vue-property-decorator';

    @Component({
        emits: [ 'input' ],
        inheritAttrs: false,
    })
    export default class Select extends Vue {
        @Prop({ type: String, default: null })
        private placeholder!: string | null;

        @Prop({ default: undefined })
        private value!: any;

        private get className() {
            return [ this.isEmpty() ? 'empty' : '', this.$attrs.class ].filter(Boolean);
        }

        // PRODUCT-26110 Task 10 (INSTANCE_LISTENERS): merges what used to be two
        // separate bindings (`v-bind="$attrs"` + `v-on="passedListeners"`) into one,
        // since `$attrs` now carries listeners too. `onInput` stays excluded (as
        // `$listeners` excluded `'input'` pre-Vue-3) so a caller's `@input` isn't
        // double-fired with a raw native Event alongside the string value emitted by
        // `onInputChange` below.
        private get passedAttrs(): Record<string, unknown> {
            return omit(this.$attrs, [ 'onInput' ]);
        }

        private isEmpty() {
            return this.value === undefined;
        }

        private onInputChange(event: Event) {
            const theValue = (event.target as HTMLSelectElement).value;
            this.$emit('input', theValue);
        }
    }
</script>
